import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StringService } from './index2.js';
import { D as DomService } from './index3.js';
import { T as TranslationService } from './index6.js';
import { d as defineCustomElement$1 } from './roche-icon2.js';

const rocheLoadingSpinnerCss = ":host{display:flex;flex-direction:column;text-align:center;min-height:100vh}@media (min-width: 20rem){:host{margin:8rem 0}}@media (min-width: 48rem){:host{margin:10rem 0}}roche-icon{fill:#706b69}.loading-text{font-family:\"roche-sans\";font-style:normal;font-weight:200;font-weight:400;font-size:var(--label--font-size--small-up);line-height:1.3125rem;margin-top:0.5rem;color:#706b69}@media (min-width: 48rem){.loading-text{font-size:var(--label--font-size--medium-up);line-height:1.3125rem}}.loading-spinner-animation{animation:loading-spinner 2s linear infinite;fill:#aec0ee}:host([dir=rtl]) .loading-spinner-animation{animation-direction:reverse}@keyframes loading-spinner{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}";
const RocheLoadingSpinnerStyle0 = rocheLoadingSpinnerCss;

const RocheLoadingSpinner = /*@__PURE__*/ proxyCustomElement(class RocheLoadingSpinner extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.icon = 'loading';
        this.translations = undefined;
    }
    async componentWillLoad() {
        this.translations = {
            loading: await TranslationService.translate('loading'),
        };
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    // eslint-disable-next-line class-methods-use-this
    render() {
        return (h(Host, { key: 'b4a3547f48d3e2b4351731ce21acf6ebd0656bae' }, h("roche-icon", { key: 'd3772d735cdc8a85cabe42e0b2cdb5cdd333758f', icon: this.icon, height: "1.5rem", class: 'loading-spinner-animation' }), h("div", { key: '134ac0580fc51ffd8bea71efaacefefd79b7c18c', class: 'loading-text' }, StringService.capitalize(this.translations.loading))));
    }
    get element() { return this; }
    static get style() { return RocheLoadingSpinnerStyle0; }
}, [1, "roche-loading-spinner", {
        "icon": [1],
        "translations": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-loading-spinner", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-loading-spinner":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheLoadingSpinner);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { RocheLoadingSpinner as R, defineCustomElement as d };

//# sourceMappingURL=roche-loading-spinner2.js.map